import { ScriptItem } from '../AddProduct/types';

export const formatCurrency = (value: number | undefined): string => {
  if (typeof value !== 'number') return 'R$ 0,00';
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const getTotalDeliveryTime = (items: ScriptItem[]): number => {
  if (!items || items.length === 0) return 0;

  return items.reduce((total, item) => {
    let deliveryTime = 0;

    switch (item.type) {
      case 'service': {
        if (item.deliveryTime) {
          if (typeof item.deliveryTime === 'string') {
            deliveryTime = parseFloat(item.deliveryTime) || 0;
          } else {
            deliveryTime = item.deliveryTime;
          }
        } else if (item.deadlineInDays) {
          deliveryTime = item.deadlineInDays;
        }
        break;
      }
      case 'rawMaterial': {
        const density = item.density || 0;
        deliveryTime = density > 0 ? Math.ceil(density / 1000) : 1;
        break;
      }
      case 'resource': {
        deliveryTime = 0;
        break;
      }
      case 'productFinal': {
        const quantity = item.quantity || 1;
        deliveryTime = quantity > 10 ? 3 : 2;
        break;
      }
    }
    return total + deliveryTime;
  }, 0);
};

export const getTotalCost = (items: ScriptItem[]): number => {
  if (!items || items.length === 0) return 0;

  return items.reduce((total, item) => {
    let cost = 0;

    switch (item.type) {
      case 'rawMaterial': {

        /*
        const materialWeight = item.weight || 0;
        const density = item.density || 1;
        const materialPricePerKg = 50;
        cost = materialWeight * density * materialPricePerKg;
        */
        cost = 0;
        break;
      }
      case 'service': {
        const firstPrice = item.prices && item.prices.length > 0
          ? parseFloat(item.prices[0].price)
          : 0;
        const executionTimeSeconds = Number(item.executionTime ?? 0);
        const executionTimeInHours = Number.isFinite(executionTimeSeconds)
          ? executionTimeSeconds / 3600
          : 1;
        cost = firstPrice * (executionTimeInHours || 1);
        break;
      }
      case 'resource': {
        const resourceWeight = item.weight || 0;
        const firstPrice = item.prices && item.prices.length > 0
          ? parseFloat(item.prices[0].price)
          : 0;
        cost = resourceWeight * firstPrice;
        break;
      }
      case 'productFinal': {
        const productQuantity = item.quantity || 1;
        const productPrice = 200;
        cost = productQuantity * productPrice;
        break;
      }
    }
    return total + cost;
  }, 0);
};

export const getTotalPrice = (items: ScriptItem[]): number => {
  if (!items || items.length === 0) return 0;

  const totalCost = getTotalCost(items);
  const margin = 1.3;
  return totalCost * margin;
}; 